import React, {
    PropTypes,
    Component
} from 'react';
import Rating from './Rating';
import {
    createReview,
    createReplyReview
} from '../actions/LoginServiceCreator';
import {
    loadServicesentity
} from '../actions/WebsiteLoadCreator';
var cookie = require('react-cookie');

class Reviews extends Component {
    static propTypes = {
        entities: PropTypes.object.isRequired
    }

    static defaultProps = {
        entities: {},

    }
    static contextTypes = {
        executeAction: React.PropTypes.func
    }
    componentWillMount() {
        this.setState({
            page: 10,
            data: this.props.entities.service[0],
        });
        var temp = this.props.entities.service[0];
        temp.sort(function(a, b) {
            a.reviewed_on = a.reviewed_on.trim().replace("Reviewed ", "").replace(" NEW", "");
            b.reviewed_on = b.reviewed_on.trim().replace("Reviewed ", "").replace(" NEW", "");
            return new Date(b.reviewed_on) - new Date(a.reviewed_on);
        });
        this.setState({
            data: temp
        });
    }
    handleClick(entity) {
        $('.pagination li a').removeClass('activePagination');
        $('#' + entity.id + '').addClass('activePagination');
        var currentPagination = entity.id * 10;
        return this.setState({
            page: currentPagination
        });
    }
    handleSort() {
        var temp = this.state.data;

        if (this.refs.reviewSort.getDOMNode().value == "date") {
            temp.sort(function(a, b) {
                a.reviewed_on = a.reviewed_on.trim().replace("Reviewed ", "").replace(" NEW", "");
                b.reviewed_on = b.reviewed_on.trim().replace("Reviewed ", "").replace(" NEW", "");
                return new Date(a.reviewed_on) - new Date(b.reviewed_on);
            });
        } else if (this.refs.reviewSort.getDOMNode().value == "ratings") {
            temp.sort(function(a, b) {
                return b.review_rating.slice(0, 1) - a.review_rating.slice(0, 1);
            });
        }
        this.setState({
            data: temp
        });
    }
    handleView() {
        var temp = this.props.entities;
        if (this.refs.filterView.getDOMNode().value == "SuperUser") {
            temp = temp.filter(function(item) {
                return item.user_rank > 4.5;
            });
        } else if (this.refs.filterView.getDOMNode().value == "Moderator") {
            temp = temp.filter(function(item) {
                return item.user_rank < 4.5 && item.user_rank > 3;
            });
        } else if (this.refs.filterView.getDOMNode().value == "Regular") {
            temp = temp.filter(function(item) {
                return item.user_rank < 3;
            });
        }
        this.setState({
            data: temp
        });
    }
    SubmitReview(entity) {
        entity.review_description = $('#text-review').val();
        entity.review_rating = JSON.parse($("#ratingone input:checked").attr('id').slice(4)) + ".0 out of 5 stars";
        entity.entity_id = entity.id;
        entity.id = "review_" + Math.random();
        entity.user_id = cookie.load('id', true);
        var locale = "en-us";
        //entity.reviewed_on = "Reviewed "+new Date().getDate()+" "+new Date().toDateString().split(" ")[1]+" "+new Date().getFullYear();
        entity.reviewed_on = "Reviewed " + new Date().getDate() + " " + new Date().toLocaleString(locale, {
            month: "long"
        }) + " " + new Date().getFullYear();
        this.context.executeAction(createReview, entity);
        $('.text-review').val("");
        $('.rating >input').removeAttr("checked");
    }
    SubmitReplyReview(entity) {
        entity.review_description = $('#text-review' + entity.index).val();
        entity.review_rating = JSON.parse($('#rating' + entity.index + ' input:checked').attr('value')) + ".0 out of 5 stars";
        entity.entity_id = entity.entity.id;
        entity.id = Math.random();
        entity.user_id = cookie.load('id', true);
        var locale = "en-us";
        //entity.reviewed_on = "Reviewed "+new Date().getDate()+" "+new Date().toDateString().split(" ")[1]+" "+new Date().getFullYear();
        entity.reviewed_on = "Reviewed " + new Date().getDate() + " " + new Date().toLocaleString(locale, {
            month: "long"
        }) + " " + new Date().getFullYear();
        this.context.executeAction(createReplyReview, entity);
        $('#text-review' + entity.index + '').val("");
        $('#rating' + entity.index + ' >input').removeAttr("checked");
    }
    rating(entity) {
        $('#ratingone >input[type="radio"]').removeAttr("checked");
        $('#star' + entity.target.title + '').prop("checked", true);
    }
    replyrating(entity) {
        $('#rating' + entity.index + ' >input[type="radio"]').removeAttr("checked");
        $('#star' + entity.rating + '-' + entity.index + '').prop("checked", true);
    }
    ReplyClick(entity) {
        $('.replycontainer').css('display', 'none');
        $('#reply-' + entity.index).toggleClass('selected');
    }
    componentDidMount() {
        $(".whirly-loader").css('visibility', 'hidden');
        $('#1').addClass('activePagination');
    }
    leftPagination(entity) {
        var currentPageId = $('.activePagination').attr('id');
        currentPageId--;
        if (currentPageId > 0) {
            $('.pagination li a').removeClass('activePagination');
            $('#' + currentPageId + '').addClass('activePagination');
            if (parseInt($('.pagination').css('left').replace('px', '')) < 0) {
                $('.pagination').css('left', (parseInt($('.pagination').css('left').replace('px', '')) + parseInt($('#' + (currentPageId) + '').css('width').replace('px', '')) + 'px'));
            }
            var currentPagination = currentPageId * 10;
            return this.setState({
                page: currentPagination
            });
        }
    }
    rightPagination(entity) {
        var currentPageId = $('.activePagination').attr('id');
        currentPageId++;
        var entitylength = Math.ceil(this.props.entities.length / 10);
        if (currentPageId <= entitylength) {
            $('.pagination li a').removeClass('activePagination');
            $('#' + currentPageId + '').addClass('activePagination');
            if (parseInt($('.pagination').css('left').replace('px', '')) <= 0) {
                $('.pagination').css('left', (parseInt($('.pagination').css('left').replace('px', '')) - parseInt($('#' + (currentPageId) + '').css('width').replace('px', '')) + 'px'));
            }
            var currentPagination = currentPageId * 10;
            return this.setState({
                page: currentPagination
            });
        }
    }
    render() {
        var entities = this.state.data;
        var reply_reviews = this.props.entities.service[1];
        var currentPage = this.state.page;
        var paginationlength = Math.ceil(entities.length / 10);
        var indents = [];
        var pages = 0;
        for (var i = 0; i < paginationlength; i++) {
            pages++;
            indents.push({
                id: pages
            });
        }
        return (
            <div>
        { (cookie.load('logged_in', true) != 0) && (
          <div className="row-fluid clearfix" style={ { "padding": "2em", "background-color": "#fff" } }>
            <div style={ { "position": "relative", "height": "15vh" } }>
              <div className="review-box" style={ { "background-color": "#F5EBEB" } }>
                <div className="expert-pic" style={ { "width": "10%" } }><i className="icon-user" style={ { "font-size": "5em" } }></i></div>
                <div className="expert-review-description">
                  <div>
                    <textarea className="text-review" id="text-review" placeholder="Write a review ..."></textarea>
                    <div style={ { "width": "100%", "height": "4em", "padding": "1em" } }>
                      <fieldset className="rating" id="ratingone">
                        <input type="radio" id="star5" name="rating" value="5" />
                        <label onClick={ this.rating.bind(this) } className="full" for="star5" title="5"></label>
                        <input type="radio" id="star4" name="rating" value="4" />
                        <label onClick={ this.rating.bind(this) } className="full" for="star4" title="4"></label>
                        <input type="radio" id="star3" name="rating" value="3" />
                        <label onClick={ this.rating.bind(this) } className="full" for="star3" title="3"></label>
                        <input type="radio" id="star2" name="rating" value="2" />
                        <label onClick={ this.rating.bind(this) } className="full" for="star2" title="2"></label>
                        <input type="radio" id="star1" name="rating" value="1" />
                        <label onClick={ this.rating.bind(this) } className="full" for="star1" title="1"></label>
                      </fieldset>
                    </div>
                  </div>
                  <div style={ { "padding-left": "1em" } }>
                    <i className="sprite-red sprite-Camera-Copy"></i><i className="sprite-red sprite-noun_video-camera_28163"></i>
                  </div>
                  <div className="entity-container-reviewsbtn post-btn" style={ { "width": "10.5em" } } onClick={ this.SubmitReview.bind(this, entities[0]) }>post</div>
                </div>
              </div>
            </div>
          </div>
          ) }
        <div className="review-option-container">
          <span className="option-name">View: <select className="review-options" ref="filterView" onChange={ this.handleView.bind(this) }><option value="none">SELECT</option><option value="SuperUser">Super Users</option><option value="Moderator">Moderators</option><option value="Regular">Regular Users</option></select></span>
          <span className="option-name">Sort by: <select className="review-options" ref="reviewSort" onChange={ this.handleSort.bind(this) }><option value="none">SELECT</option><option value="date">Date</option><option value="ratings">Ratings</option></select></span>
        </div>
        <div className="review-content">
          { entities.length } Reviews from our community</div>
        { entities.map(function(entity, index) {
            return (
              <div>
                { ((null !== entity.review_description) && ((index >= currentPage - 10) && (index <= currentPage))) && (
                  <div className="row-fluid clearfix" style={ { "padding": "0.5em 2em", "background-color": "#fff" } }>
                    <div style={ { "position": "relative" } }>
                      <div className="review-detail" style={ { "background-color": "#F5EBEB" } }>
                        <div className="expert-pic">
                          <i className="icon-user" style={ { "font-size": "5em" } }></i>
                        </div>
                        <span className="review-expert-description"/>
                        <div className="review-expert-detail" style={ { "text-align": "center", "background-color": "#D6C7C7" } }>
                          <div style={ { "text-align": "center", "margin-right": "1em" } }>
                            <div>
                              { entity.reviewed_on.trim().replace("Reviewed ", "").replace(" NEW", "") }
                            </div>
                          </div>
                          <div className="category-rating">
                            <Rating entities={ { rating: JSON.parse(entity.review_rating.slice(0, 1)) } } />
                          </div>
                          <div className="review-flag">
                            <i className="sprite-white sprite-Flag"></i>
                          </div>
                        </div>
                        { reply_reviews.map(function(replyentity, index) {
                            return (
                              <div>
                                { (entity.review_id === replyentity.review_id) && (
                                  <div className="review-detail" style={ { "background-color": "#F5EBEB" } }>
                                    <div className="expert-pic">
                                      <i className="icon-user" style={ { "font-size": "5em" } }></i>
                                    </div>
                                    <span className="review-expert-description"/>
                                    <div className="review-expert-detail" style={ { "text-align": "center", "background-color": "#D6C7C7", "margin-left": "81.15%" } }>
                                      <div style={ { "text-align": "center", "margin-right": "1em" } }>
                                      </div>
                                      <div className="category-rating">
                                        <Rating entities={ { rating: JSON.parse(replyentity.review_replyrating.slice(0, 1)) } } />
                                      </div>
                                      <div className="review-flag">
                                        <i className="sprite-white sprite-Flag"></i>
                                      </div>
                                    </div>
                                  </div>
                                  ) }
                              </div>
                              );
                          }.bind(this)) }
                      </div>
                    </div>
                  </div>
                  ) }
              </div>
              );
          }.bind(this)) }
        { (0 < entities.length) && (
          <div className="pagination-container">
            <i className="sprite-red sprite-Left-Chevron-Copy" onClick={ this.leftPagination.bind(this) } style={ { "position": "relative", "float": "left", "cursor": "pointer" } }></i>
            <div className="clearfix pagination-ul-wrap">
              <ul className="pagination service-pagination">
                { indents.map(function(entity, index) {
                    var boundclick = this.handleClick.bind(this, entity);
                    return (
                      <li style={ { "cursor": "pointer" } }>
                        <a id={ entity.id } onClick={ boundclick }>
                          { entity.id }
                        </a>
                      </li>
                      );
                  }, this) }
              </ul>
            </div>
            <i className="sprite-red sprite-Right-Chevron-Copy" onClick={ this.rightPagination.bind(this) } style={ { "position": "relative", "float": "left", "cursor": "pointer" } }></i>
          </div>
          ) }
      </div>
        );
    }
}

module.exports = Reviews;


// WEBPACK FOOTER //
// ./src/components/Reviews.js